<template>
  <b-card header-class="d-flex justify-content-between">
    <b-alert :show="errors.any()" variant="danger" class="px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>

    <template v-slot:header>
      <div>
        <font-awesome-icon
          v-if="displayName"
          icon="user"
          class="align-middle text-muted"
          :class="{'mr-1': $dir.ltr, 'ml-1': $dir.rtl}"
        />
        {{ displayName }}
      </div>

      <b-btn
        class="p-0"
        variant="link"
        :title="$t('shared.remove')"
        v-b-tooltip
        @click="emitRemove"
      >
        <font-awesome-icon icon="trash-alt" class="text-danger align-middle"/>
      </b-btn>
    </template>

    <b-row>
      <b-col md="5">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend is-text>
              {{ $t('account.firstName') }}
              <required-symbol v-if="!model.lastName"/>
            </b-input-group-prepend>

            <b-form-input
              dir="auto"
              :name="$t('account.firstName')"
              v-validate="model.lastName ? null : 'required'"
              v-model="model.firstName"
            />
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <b-input-group>
            <b-input-group-prepend is-text>
              {{ $t('account.lastName') }}
              <required-symbol v-if="!model.firstName"/>
            </b-input-group-prepend>

            <b-form-input
              dir="auto"
              :name="$t('account.lastName')"
              v-validate="model.firstName ? null : 'required'"
              v-model="model.lastName"
            />
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <b-input-group :prepend="$t('shared.position')">
            <b-form-input dir="auto" v-model="model.position"/>
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <b-input-group :prepend="$t('account.gender')">
            <b-form-select :options="genders" v-model="model.gender"/>
          </b-input-group>
        </b-form-group>

        <b-form-group>
          <date-picker
            disable-dates-after-today
            :label="$t('account.birthdate')"
            v-model="model.birthday"
          />
        </b-form-group>

        <b-form-group class="mb-md-0">
          <b-textarea
            :rows="11"
            :placeholder="$t('shared.notes')"
            v-model="model.fields.notes"
          />
        </b-form-group>
      </b-col>

      <b-col md="7">
        <fields ref="fieldsEditor" v-model="model.fields"/>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { DatePicker } from '@/components/shared'
import Fields from './Fields/index'

export default {
  name: 'Item',
  components: {
    DatePicker,
    Fields
  },
  props: {
    value: Object
  },
  data () {
    return {
      genders: [
        { value: null, text: this.$t('shared.choose') },
        { value: 0, text: this.$t('account.female') },
        { value: 1, text: this.$t('account.male') }
      ]
    }
  },
  computed: {
    model:{
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    displayName () {
      return this.$api.account.getUserDisplayName(this.model)
    }
  },
  methods: {
    emitRemove () {
      if (confirm(this.$t('shared.areYouSureToRemoveThisItem'))) {
        this.$emit('remove', this.model.id)
      }
    },
    validateAll () {
      return this.$validator.validateAll()
    },
    validateFields () {
      return this.$refs.fieldsEditor.validateAll()
    }
  }
}
</script>